import $ from "jquery";

$(function () {
    const heroMessages = document.querySelectorAll(".hero-message-wrap");
    const lockupImage = document.querySelector(".lockup-image");
    const header = document.querySelector(".header");
    

	if (!heroMessages.length) return;

    heroMessages.forEach((wrap) => {
		const message = wrap.querySelector(".hero-message");
		if (!message) return;

		let messageHeight = message.offsetHeight;
        let originalTop = wrap.getBoundingClientRect().top + window.scrollY;

		const updateMeasurements = () => {
			messageHeight = message.offsetHeight;
			originalTop = wrap.getBoundingClientRect().top + window.scrollY;
		};

		const updateState = () => {
			const scrollBottom = window.scrollY + window.innerHeight;

			// If the bottom of the viewport has NOT yet reached the element's original position,
			// keep it fixed. Once it does, return it to normal flow.
			if (scrollBottom < originalTop + messageHeight) {
				message.classList.add("is-fixed");
                wrap.style.height = `${messageHeight}px`;
                lockupImage.classList.add("is-fixed");
                header.classList.add("is-fixed");
			} else {
				message.classList.remove("is-fixed");
                wrap.style.height = "";
                lockupImage.classList.remove("is-fixed");
                header.classList.remove("is-fixed");
			}
		};

		updateMeasurements();
		updateState();

		window.addEventListener("scroll", updateState);
		window.addEventListener("resize", () => {
			updateMeasurements();
			updateState();
		});
	});
});
